module.exports = __webpack_public_path__ + "8aa88ce0d761e5bfcf923c2e6b891605.jpg";